import { callPostApi } from "../../function/ApiCallFunction";

export function adminPost(mod, data_arr = {}) {
  return callPostApi("superadmin", { mod, data_arr });
}
